<template>
  <base-layout toolbarActive>
    <template #toolbarBase>
      <div v-if="!isMobile">
        <router-link
          :to="{ name: 'themeCreate' }"
          class="link font-weight-medium"
        >
          <icon-plus></icon-plus> Добавить новую тему
        </router-link>
      </div>
      <div v-else class="text-xs-center">
        <span class="font-weight-bold display-2">
          Темы страницы авторизации
        </span>
      </div>
    </template>

    <hint-widget
      hintName="theme"
      type="text"
      class="mx-4 mb-3"
      btnMore
    ></hint-widget>

    <v-container
      :class="{ 'pa-0': isMobile, 'grid-list-xl': !isMobile }"
      fluid
      pt-0
    >
      <v-layout wrap>
        <v-flex
          v-for="theme in $store.getters.themeList"
          :key="theme.id"
          md4
          sm6
          xs12
          :class="{ 'border-dark py-0': isMobile }"
        >
          <theme-item :theme="theme"></theme-item>
        </v-flex>
      </v-layout>
    </v-container>
  </base-layout>
</template>

<script>
import BaseLayout from "../components/layout/BaseLayout.vue";
import IconPlus from "../components/icon/IconPlus.vue";
import ThemeItem from "../components/theme/ThemeItem.vue";
import HintWidget from "../components/common/HintWidget.vue";

export default {
  name: "ThemeView",

  components: {
    ThemeItem,
    IconPlus,
    BaseLayout,
    HintWidget
  },

  data: () => ({}),

  mounted() {
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad");
    // загружаем список тем
    this.$store.commit("SET_THEME_IS_LOADED", false);
    this.$store.dispatch("themeListLoad");
    // открываем сообщение при загрузке старницы
    if (this.isMobile) {
      this.$store.dispatch("popupInfoOpen", {
        text:
          "Добавить новые темы или внести изменения в цвета существующих" +
          " тем вы можете с планшета или компьютера",
        timeout: 5000
      });
    }
  },
  computed: {
    // для мобильной версии
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  methods: {}
};
</script>
